import {
  UPDATE_STATUS,
} from './base';

export const RECORD_LINKAGE = 'linkage';

export const RECORD_LINKAGE_PAGE_TYPE_TASK = 'task';
export const RECORD_LINKAGE_PAGE_TYPE_JOB_TEMPLATE = 'jobTemplate';
export const RECORD_LINKAGE_PAGE_TYPE_JOB = 'job';

export const RECORD_LINKAGE_PAGE_TYPES = [
  RECORD_LINKAGE_PAGE_TYPE_TASK,
  RECORD_LINKAGE_PAGE_TYPE_JOB_TEMPLATE,
  RECORD_LINKAGE_PAGE_TYPE_JOB,
];

export const RECORD_LINK_FIELDS = {
  NAME: 'name',
  URL: 'url',
  UPDATE_STATUS: 'updateStatus',
};

export const RECORD_LINK_INITIAL_VALUES = {
  [RECORD_LINK_FIELDS.NAME]: '',
  [RECORD_LINK_FIELDS.URL]: '',
  [RECORD_LINK_FIELDS.UPDATE_STATUS]: UPDATE_STATUS.ADD,
};

export const RECORD_LINKAGE_INITIAL_VALUES = [];
